import { useCurrentUser } from '../useCurrentUser/useCurrentUser';

export const useFirmId = () => {
  const user = useCurrentUser();

  return {
    isFirm: !!user?.firmId,
    loading: Object.keys(user).length === 0,
    firmId: user?.firmId,
    isNotFirm: Object.keys(user).length !== 0 && !user?.firmId,
  };
};
